module.exports = __webpack_public_path__ + "static/media/icon-tick-circle-purple.02f18471.svg";